// Libraries
import React, { useEffect, useRef, useState } from 'react'
import moment from 'moment'
import { isNil } from 'lodash'
import PropTypes from 'prop-types'
import { Formik, Form } from 'formik'
import { message, Modal, Button } from 'antd'
import { PlusCircle as Plus } from '@styled-icons/bootstrap/PlusCircle'
// Api
import { epagAPI } from '../../../../API/epagAPI'
// Hooks
import { useGetToken } from '../../../../hooks/useGetToken'
import { useInputValue } from '../../../../hooks/useInputValue'
// Styles
import { ErrorText } from '../../Inputs/styles'
import { TitleBox } from '../../SectionProfile/styles'
import { ButtonContainer } from '../../../Base/Forms/styles'
import { WrapperInputSkills, WrapperAddSkill, AddSkillButtonBox } from '../styles'
// Utils
import {
  disableFutureDates,
  disablePastDates,
  updateSkillsByMode,
  removeTagByIndex,
  tagsMapper,
  setMessageWarning,
  validateSpelling
} from '../../../../utils/utils'
// Components
import { Tags } from '../../Tags'
import { Spinner } from '../../../Spinner'
import Date from '../../../Base/Forms/Datepicker'
import { LetterCounter } from '../../LetterCounter'
import TextArea from '../../../Base/Forms/TextArea'
import { SectionProfile } from '../../SectionProfile'
import TextInput from '../../../Base/Forms/TextInput'
import FormikSelect from '../../../Base/Forms/Select'
import FormikCheckbox from '../../../Base/Forms/Checkbox'
import { SingleSkillModal } from '../../../Modals/GenericModals'
// Constants
import { EXPERIENCE_MODAL_SCHEMA } from './schema'
import { EXPERIENCE_MODAL_SIZES } from '../../../../constants/modals'
import { Text } from '../../../../constants/TextConstants'
import { FrameworksAndTechnologies, programmingLanguages, testing, OrangeColor } from '../../../../constants/constants'

export const ModalExperience = ({
  data,
  openModal,
  setOpenModal,
  setModelProfile,
  indexToModify,
  mode,
  skillName,
  isSavedChange,
  canSelectOnePage = true
}) => {
  const formikRef = useRef()
  const ErrorRequest = useInputValue(false)
  const [responsabilitiesSpellingError, setResponsabilitiesSpellingError] = useState('')
  const [projectDescriptionSpellingError, setProjectDescriptionSpellingError] = useState('')
  const [additionalInfoSpellingError, setAdditionalInfoSpellingError] = useState('')
  const [achievementsSpellingError, setAchievementsSpellingError] = useState('')
  const [programmingSkills, setProgrammingSkills] = useState([])
  const [ToolsAndTechniques, setToolsAndTechniques] = useState([])
  const [TestingSkills, setTestingSkills] = useState([])
  const [modalProgrammingSkills, setModalProgrammingSkills] = useState(false)
  const [modalToolsAndTechniques, setModalToolsAndTechniques] = useState(false)
  const [modalTestingSkills, setModalTestingSkills] = useState(false)
  const [skills, setSkills] = useState([])
  const [skillList, setValueSkillList] = useState([])
  const { token } = useGetToken()
  const [loadingConfirm, setLoadingConfirm] = useState(false)
  const [newSkill, setNewSkill] = useState('')
  const timer = useRef(null)
  const delayVerifySpelling = 1000
  const [isValidating, setIsValidating] = useState(false)

  useEffect(() => {
    if (openModal === true) {
      setProgrammingSkills(data.programming_languages)
      setToolsAndTechniques(data.technologies_and_frameworks)
      setTestingSkills(data.testing_and_development_tools)
      setNewSkill('')
    }
  }, [openModal])

  useEffect(() => {
    if (openModal) {
      getSkills()
    }
  }, [token, openModal])

  const getSkills = () => {
    if (token !== null && skills) {
      epagAPI
        .GetSkills(skillName, token)
        .then((response) => {
          if (response.length > 0) {
            const list = updateSkillsByMode(mode, response[0], [])
            setValueSkillList(
              list.sort(function (a, b) {
                return a.toLowerCase().localeCompare(b.toLowerCase())
              })
            )
            ErrorRequest.setErrorText('')
            ErrorRequest.setError(false)
          }
        })
        .catch((error) => {
          console.error(error)
          setValueSkillList([''])
        })
    }
  }

  const submitAndValidate = async (values) => {
    const {
      jobTitle,
      projectName,
      isCurrentlyWork,
      jobDateTo,
      jobDateFrom,
      projectDescription,
      achievements,
      jobAndResponsibilities,
      isExperienceInsideEndava,
      additionalInfo,
      additionalInfoDesc,
      isSelectSummary,
      industrySector
    } = values
    if (isValidating) return
    setIsValidating(true)
    const dateToValue = isCurrentlyWork ? 'Currently' : jobDateTo.format('YYYY-MM-DD')
    const objectToUpdate = {
      project_rol: jobTitle,
      industry: industrySector,
      project_name: projectName,
      started_date: jobDateFrom.format('YYYY-MM-DD'),
      ended_date: dateToValue,
      description: projectDescription,
      achievements: achievements,
      responsabilities: jobAndResponsibilities,
      programming_languages: programmingSkills,
      technologies_and_frameworks: ToolsAndTechniques,
      testing_and_development_tools: TestingSkills,
      isEndavaExperience: isExperienceInsideEndava,
      additional_info_title: additionalInfo,
      additional_info_desc: additionalInfoDesc,
      is_one_page: isSelectSummary
    }
    if (mode === 'update') {
      setModelProfile((prevState) => {
        const arrayExperience = [...prevState.professional_experience]
        arrayExperience[indexToModify] = objectToUpdate
        setIsValidating(false)
        return { ...prevState, professional_experience: arrayExperience }
      })
    } else if (mode === 'create') {
      setModelProfile((prevState) => {
        const arrayExperience = [...prevState.professional_experience]
        arrayExperience.push(objectToUpdate)
        setIsValidating(false)
        return { ...prevState, professional_experience: arrayExperience }
      })
    }
    setIsValidating(false)
    setOpenModal(false)
  }

  const validateDates = (date, jobDateFrom) => {
    return disableFutureDates(date) || disablePastDates(date, jobDateFrom)
  }

  const verifySpelling = (value, setError) => {
    validateSpelling(token, value, null, setError)
  }

  const verifySpellingWitDelay = (value, setError) => {
    clearTimeout(timer.current)
    timer.current = setTimeout(() => verifySpelling(value, setError), delayVerifySpelling)
  }

  const showDeleteConfirm = (event, item, resetForm) => {
    event.stopPropagation()
    confirm({
      title: Text.DeleteAlertItemMessage,
      centered: true,
      icon: '',
      okText: 'Confirm',
      cancelText: 'Cancel',
      onOk() {
        deleteItem(item)
        resetForm()
      },
      onCancel() {}
    })
  }

  const info = (value) => {
    Modal.info({
      title: `The value "${value}" was deleted`,
      icon: '',
      centered: true,
      onOk() {}
    })
  }

  const deleteItem = (item) => {
    deleteSkill(item)
    setNewSkill('')
  }

  const deleteSkill = (value) => {
    epagAPI
      .DeleteSkill(skillName, value, token)
      .then((response) => {
        const skillsByMode = updateSkillsByMode(mode, response, [])
        const list = skillsByMode.filter((skillVal) => skillVal !== value)
        setValueSkillList(
          list.sort(function (a, b) {
            return a.toLowerCase().localeCompare(b.toLowerCase())
          })
        )
        info(value)
        setSkills(
          skillList.filter(function (item) {
            return item !== value
          })
        )
      })
      .catch((error) => {
        message.success(error.message, 3)
      })
  }

  const addNewSkill = (setValue, maxLength) => {
    if (newSkill.trim() !== '') {
      if (newSkill.length > maxLength) {
        setMessageWarning(Text.MaxLength)
      } else {
        const skillAlreadyExists = skillList.some((item) => item === newSkill)
        if (!skillAlreadyExists) {
          setLoadingConfirm(true)
          epagAPI
            .CreateSkill(skillName, newSkill, token)
            .then((response) => {
              setValueSkillList([...skillList, newSkill])
              setValue('industrySector', newSkill)
              setSkills(skillList)
              ErrorRequest.setErrorText('')
              ErrorRequest.setError(false)
              setLoadingConfirm(false)
              setNewSkill('')
              message.success(Text.NewItemAdded)
            })
            .catch((error) => {
              ErrorRequest.setErrorText(error.message)
              ErrorRequest.setError(true)
              setLoadingConfirm(false)
            })
        } else {
          setMessageWarning(Text.ErrorAddingItem, newSkill)
        }
      }
    } else {
      setMessageWarning(Text.ErrorEmptyInput, Text.IndustrySector)
      setLoadingConfirm(false)
    }
  }

  const AddIt = ({ setValue, maxLength }) => (
    <WrapperAddSkill onClick={() => addNewSkill(setValue, maxLength)}>
      {loadingConfirm ? (
        <Spinner top='10px' loadingText='Saving...' />
      ) : (
        <AddSkillButtonBox>
          <Plus size={25} color={OrangeColor} />
          <p>Add new item</p>
        </AddSkillButtonBox>
      )}
    </WrapperAddSkill>
  )

  AddIt.propTypes = {
    setValue: PropTypes.func,
    maxLength: PropTypes.number
  }

  const { confirm } = Modal

  const removeSkill = (index, setSkillsFunction) => {
    removeTagByIndex(index, setSkillsFunction)
    isSavedChange(true)
  }

  const emptyStringIfUndefined = (value) => (typeof value === 'undefined' ? '' : value)

  const onCancel = () => {
    const {
      jobTitle,
      industrySector,
      projectName,
      jobDateFrom,
      jobDateTo,
      isCurrentlyWork,
      projectDescription,
      achievements,
      jobAndResponsibilities,
      isExperienceInsideEndava,
      additionalInfo,
      additionalInfoDesc,
      isSelectSummary
    } = formikRef?.current?.values

    const dateFrom = jobDateFrom ? jobDateFrom.format('YYYY-MM-DD') : ''
    const dateTo = jobDateTo ? jobDateTo.format('YYYY-MM-DD') : ''
    const currentlyWork = isCurrentlyWork ? 'Currently' : ''

    if (
      dateFrom !== data.started_date ||
      (data.ended_date === 'Currently' ? currentlyWork !== data.ended_date : dateTo !== data.ended_date) ||
      jobTitle !== data.project_rol ||
      industrySector !== emptyStringIfUndefined(data.industry) ||
      additionalInfo !== emptyStringIfUndefined(data.additional_info_title) ||
      additionalInfoDesc !== emptyStringIfUndefined(data.additional_info_desc) ||
      (projectName !== data.project_name && !isNil(data.project_name)) ||
      jobAndResponsibilities !== emptyStringIfUndefined(data.responsabilities) ||
      projectDescription !== emptyStringIfUndefined(data.description) ||
      (achievements !== data.achievements && !isNil(data.achievements)) ||
      programmingSkills !== data.programming_languages ||
      ToolsAndTechniques !== data.technologies_and_frameworks ||
      TestingSkills !== data.testing_and_development_tools ||
      (isExperienceInsideEndava !== data.isEndavaExperience && !isNil(data.isEndavaExperience)) ||
      (isSelectSummary !== data.is_one_page && !isNil(data.is_one_page))
    ) {
      showConfirm()
    } else {
      setOpenModal(false)
      isSavedChange(true)
      formikRef?.current?.resetForm()
    }
  }

  const getOptionsFromArray = (array, tooltips = [], optionToBeFilter = []) =>
    array
      ? array
        .filter((item) => !optionToBeFilter.find((e) => e.skill_name === item))
        .map((item) => ({ value: item, label: item, tooltipText: tooltips[item] }))
      : []

  const showConfirm = () => {
    confirm({
      title: null,
      content: (
        <WrapperInputSkills spaceStyle={'flex-start'}>
          <div style={{ margin: '3px' }}>
            <TitleBox>
              {"The changes haven't been saved. Are you sure you want to move out and lose your changes?"}
            </TitleBox>
          </div>
        </WrapperInputSkills>
      ),
      okText: 'Yes',
      cancelText: 'No',

      onOk() {
        setOpenModal(false)
        isSavedChange(true)
      },

      onCancel() {}
    })
  }

  const customFilter = (input, option) => {
    const optionList = option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
    setNewSkill(input)
    return optionList
  }

  return (
    <Modal
      title={Text.EditExperience}
      open={openModal}
      maskClosable={false}
      okText={Text.Add}
      width='80%'
      onCancel={() => onCancel()}
      destroyOnClose={true}
      keyboard={false}
      footer={null}>
      <Formik
        initialValues={{
          jobDateFrom: data && data.started_date ? moment(data.started_date) : '',
          jobDateTo: data.ended_date && data.ended_date !== 'Currently' ? moment(data.ended_date) : '',
          isCurrentlyWork: data.ended_date === 'Currently',
          isExperienceInsideEndava: !!data.isEndavaExperience,
          isSelectSummary: !!data.is_one_page,
          jobTitle: data.project_rol || '',
          industrySector: data.industry || '',
          projectName: data.project_name || '',
          jobAndResponsibilities: data.responsabilities || '',
          projectDescription: data.description || '',
          additionalInfo: data.additional_info_title || '',
          additionalInfoDesc: data.additional_info_desc || '',
          achievements: data.achievements || ''
        }}
        validationSchema={EXPERIENCE_MODAL_SCHEMA}
        initialTouched={{ skill: true, level: true }}
        onSubmit={(values, { resetForm }) => {
          submitAndValidate(values)
          resetForm()
        }}
        innerRef={formikRef}>
        {({ values, isValid, setValues, handleSubmit, setFieldValue, resetForm, setFieldError, setFieldTouched }) => {
          useEffect(() => {
            if (responsabilitiesSpellingError) {
              setFieldError('jobAndResponsibilities', Text.SpellErrors + responsabilitiesSpellingError)
              setFieldTouched('jobAndResponsibilities', true, false)
            }

            if (projectDescriptionSpellingError) {
              setFieldError('projectDescription', Text.SpellErrors + projectDescriptionSpellingError)
              setFieldTouched('projectDescription', true, false)
            }

            if (additionalInfoSpellingError) {
              setFieldError('additionalInfoDesc', Text.SpellErrors + additionalInfoSpellingError)
              setFieldTouched('additionalInfoDesc', true, false)
            }

            if (achievementsSpellingError) {
              setFieldError('achievements', Text.SpellErrors + achievementsSpellingError)
              setFieldTouched('achievements', true, false)
            }
          }, [responsabilitiesSpellingError, projectDescriptionSpellingError, additionalInfoSpellingError, achievementsSpellingError, setFieldError, setFieldTouched])

          return (
            <Form>
              <WrapperInputSkills>
                <Date
                  name='jobDateFrom'
                  data-testid='job-date-from'
                  placeholder={Text.From}
                  disabledDate={disableFutureDates}
                />
                <Date
                  name='jobDateTo'
                  data-testid='job-date-to'
                  disabledDate={(date) => validateDates(date, values.jobDateFrom)}
                  disabled={values?.isCurrentlyWork}
                  placeholder={
                    values.isCurrentlyWork ? Text.To : Text.ToRequired
                  }
                  style={{ marginLeft: '20px' }}
                />
                <FormikCheckbox
                  name='isCurrentlyWork'
                  label='I am currently working in this role'
                  onChange={(ev) => {
                    setValues({
                      ...values,
                      isCurrentlyWork: ev?.target?.checked || false,
                      jobDateTo: ev?.target?.checked ? '' : values.jobDateTo
                    })
                  }}
                  style={{ marginLeft: '20px' }}
                />
              </WrapperInputSkills>
              <WrapperInputSkills>
                <FormikCheckbox
                  name='isExperienceInsideEndava'
                  label='Experience Inside Endava'
                  style={{ marginTop: '20px' }}
                  data-testid='endava-experience'
                />
                <FormikCheckbox
                  name='isSelectSummary'
                  label={Text.SelectSummaryTemplate}
                  disabled={!canSelectOnePage}
                  tooltip={{ placement: 'right', title: Text.OnePageCheckboxTooltipMessage }}
                  style={{ marginTop: '20px', marginLeft: '10px' }}
                  data-testid='endava-one-page'
                />
              </WrapperInputSkills>
              <WrapperInputSkills>
                <TextInput
                  name='jobTitle'
                  data-testid='job-title'
                  title={Text.Title}
                  placeholder={Text.JobTitle}
                  style={{ marginTop: '20px', width: '100%' }}
                  maxLength={(EXPERIENCE_MODAL_SIZES.maxLengthJobTitle + 1)}
                />
              </WrapperInputSkills>
              <LetterCounter actual={values && values.jobTitle ? values.jobTitle.length : 0} max={EXPERIENCE_MODAL_SIZES.maxLengthJobTitle} />
              <WrapperInputSkills>
                <FormikSelect
                  showSearch
                  showDeleteOption
                  name='industrySector'
                  resetForm={resetForm}
                  title='* Industry Sector'
                  data-testid='select-industry'
                  onDeleteOption={showDeleteConfirm}
                  options={getOptionsFromArray(skillList, [], [])}
                  containerStyle={{ marginTop: '20px', width: '100%' }}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  filterOption={(input, option) => customFilter(input, option)}
                  selectStyle={{
                    width: '100%',
                    border: '1px solid #667080',
                    borderRadius: '6px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  dropdownRender={(menu) => (
                    <div>
                      {menu}
                      <AddIt add={true} setValue={setFieldValue} maxLength={EXPERIENCE_MODAL_SIZES.maxLengthIndustrySector}/>
                    </div>
                  )}
                />
              </WrapperInputSkills>
              <LetterCounter
                actual={values && values.industrySector ? values.industrySector.length : 0}
                max={EXPERIENCE_MODAL_SIZES.maxLengthIndustrySector}
              />
              <WrapperInputSkills>
                <TextInput
                  name='projectName'
                  data-testid='project-name'
                  title={Text.ProjectName}
                  placeholder={Text.ProjectName}
                  style={{ marginTop: '20px', width: '100%' }}
                  maxLength={(EXPERIENCE_MODAL_SIZES.maxLengthProjectName + 1)}
                />
              </WrapperInputSkills>
              <LetterCounter
                actual={values && values.projectName ? values.projectName.length : 0}
                max={EXPERIENCE_MODAL_SIZES.maxLengthProjectName}
              />
              <WrapperInputSkills>
                <TextArea
                  title={Text.JobResponsibilities}
                  placeholder={Text.JobAndResponsibilities}
                  name='jobAndResponsibilities'
                  rows={5}
                  data-testid={'job-responsibilities'}
                  style={{ marginTop: '20px', width: '100%' }}
                  maxLength={(EXPERIENCE_MODAL_SIZES.maxLengthJobResponsibilities + 1)}
                  onKeyUp={() => verifySpellingWitDelay(values.jobAndResponsibilities, setResponsabilitiesSpellingError)}
                />
              </WrapperInputSkills>
              <LetterCounter
                actual={values && values.jobAndResponsibilities ? values.jobAndResponsibilities.length : 0}
                max={EXPERIENCE_MODAL_SIZES.maxLengthJobResponsibilities}
              />
              <WrapperInputSkills>
                <TextArea
                  title={Text.ProjectDescription}
                  placeholder={Text.ProjectDescription}
                  rows={5}
                  data-testid={'project-description'}
                  name='projectDescription'
                  style={{ marginTop: '20px', width: '100%' }}
                  maxLength={(EXPERIENCE_MODAL_SIZES.maxLengthProjectDescription + 1)}
                  onKeyUp={() => verifySpellingWitDelay(values.projectDescription, setProjectDescriptionSpellingError)}
                />
              </WrapperInputSkills>
              <LetterCounter
                actual={values && values.projectDescription ? values.projectDescription.length : 0}
                max={EXPERIENCE_MODAL_SIZES.maxLengthProjectDescription}
              />
              <WrapperInputSkills>
                <TextInput
                  title={Text.AdditionalInfo}
                  placeholder={Text.AdditionalInfo}
                  tooltip={{ placement: 'topLeft', title: Text.AdditionalInfoTooltipMessage }}
                  data-testid='additional-info-title'
                  name='additionalInfo'
                  style={{ marginTop: '20px', width: '100%' }}
                  maxLength={(EXPERIENCE_MODAL_SIZES.maxLengthAdditionalInfoTitle + 1)}
                />
              </WrapperInputSkills>
              <LetterCounter
                actual={values && values.additionalInfo ? values.additionalInfo.length : 0}
                max={EXPERIENCE_MODAL_SIZES.maxLengthAdditionalInfoTitle}
              />
              <WrapperInputSkills>
                <TextArea
                  placeholder={Text.AdditionalInfoDesc}
                  rows={5}
                  data-testid={'additional-info-desc'}
                  name='additionalInfoDesc'
                  style={{ marginTop: '20px', width: '100%' }}
                  maxLength={(EXPERIENCE_MODAL_SIZES.maxLengthAdditionalInfoDesc + 1)}
                  onKeyUp={() => verifySpellingWitDelay(values.additionalInfoDesc, setAdditionalInfoSpellingError)}
                />
              </WrapperInputSkills>
              <LetterCounter
                actual={values && values.additionalInfoDesc ? values.additionalInfoDesc.length : 0}
                max={EXPERIENCE_MODAL_SIZES.maxLengthAdditionalInfoDesc}
              />
              <WrapperInputSkills>
                <TextArea
                  title={Text.Achievements}
                  placeholder={Text.Achievements}
                  rows={5}
                  data-testid={'achievements'}
                  name='achievements'
                  style={{ marginTop: '20px', width: '100%' }}
                  maxLength={(EXPERIENCE_MODAL_SIZES.maxLengthAchievements + 1)}
                  onKeyUp={() => verifySpellingWitDelay(values.achievements, setAchievementsSpellingError)}
                />
              </WrapperInputSkills>
              <LetterCounter
                actual={values && values.achievements ? values.achievements.length : 0}
                max={EXPERIENCE_MODAL_SIZES.maxLengthAchievements}
              />
              <SectionProfile title={Text.ProgrammingLanguages} ClickButton={() => setModalProgrammingSkills(true)}>
                <Tags
                  data={tagsMapper(programmingSkills)}
                  removeItemFunc={(index) => removeSkill(index, setProgrammingSkills)}
                  isDragDisable={true}
                />
              </SectionProfile>

              <SectionProfile title={Text.Frameworks} ClickButton={() => setModalToolsAndTechniques(true)}>
                <Tags
                  data={tagsMapper(ToolsAndTechniques)}
                  removeItemFunc={(index) => removeSkill(index, setToolsAndTechniques)}
                  isDragDisable={true}
                />
              </SectionProfile>

              <SectionProfile title={Text.Testing} ClickButton={() => setModalTestingSkills(true)}>
                <Tags
                  data={tagsMapper(TestingSkills)}
                  removeItemFunc={(index) => removeSkill(index, setTestingSkills)}
                  isDragDisable={true}
                />
              </SectionProfile>
              {/* {!!ErrorRequest.ErrorValue && <ErrorText>{ErrorRequest.ErrorText}</ErrorText>} */}

              <SingleSkillModal
                open={modalProgrammingSkills}
                setModal={setModalProgrammingSkills}
                setModelProfile={setProgrammingSkills}
                initialState={programmingSkills}
                title={Text.ProgrammingLanguages}
                subtitle={Text.SkillName}
                mode='programmingInModal'
                skillName={programmingLanguages}
                applyLevel={false}
                isSavedChange={isSavedChange}
              />

              <SingleSkillModal
                open={modalToolsAndTechniques}
                setModal={setModalToolsAndTechniques}
                setModelProfile={setToolsAndTechniques}
                initialState={ToolsAndTechniques}
                title={Text.Frameworks}
                subtitle={Text.SkillName}
                mode='ToolsAndTechniquesModal'
                skillName={FrameworksAndTechnologies}
                applyLevel={false}
                isSavedChange={isSavedChange}
              />

              <SingleSkillModal
                open={modalTestingSkills}
                setModal={setModalTestingSkills}
                setModelProfile={setTestingSkills}
                initialState={TestingSkills}
                title={Text.Testing}
                subtitle={Text.SkillName}
                mode='TestingInModal'
                skillName={testing}
                applyLevel={false}
                isSavedChange={isSavedChange}
              />
              {!!ErrorRequest.ErrorValue && <ErrorText>{ErrorRequest.ErrorText}</ErrorText>}
              <ButtonContainer>
                <Button onClick={onCancel} style={{ marginRight: '10px' }}>
                  Cancel
                </Button>
                <Button type='primary' onClick={() => handleSubmit()} disabled={!isValid || responsabilitiesSpellingError !== '' || projectDescriptionSpellingError !== '' || additionalInfoSpellingError !== '' || achievementsSpellingError !== ''} data-testid='save-button'>
                  Add
                </Button>
              </ButtonContainer>
            </Form>
          )
        }}
      </Formik>
    </Modal>
  )
}

ModalExperience.propTypes = {
  data: PropTypes.object,
  setModelProfile: PropTypes.func,
  indexToModify: PropTypes.number,
  openModal: PropTypes.bool,
  mode: PropTypes.string,
  setOpenModal: PropTypes.func,
  skillName: PropTypes.string,
  isSavedChange: PropTypes.func,
  canSelectOnePage: PropTypes.bool
}
